import * as THREE from "three";
import React from "react";
import {
  SPHERE_RADIUS,
  getWindowLocalCoordSystem,
  getMeshSensorColor,
  getWindowPolygonYUp,
  isTempSensor,
  applySensorOffset,
} from "./utils";
import { SphereInstancedMesh } from "../threeDComponent/InstancedMesh";

const AddMeshSensors = ({
  sensors,
  windowCoordSystem,
  hoveredSensor,
  selectedSensors,
  handleSensorClick,
  allWindows,
  sensorOffset,
  onPointerEnter,
  onPointerLeave,
}) => {
  const setColor = (sensor) =>
    new THREE.Color(
      getMeshSensorColor(
        sensor.id,
        hoveredSensor,
        selectedSensors,
        isTempSensor(sensor)
      )
    );

  const onClick = (config) => {
    config.stopPropagation();
    const sensor = sensors[config.instanceId];
    handleSensorClick(sensor, config);
  };

  const objects = sensors?.map((sensor) => {
    const window = allWindows?.find((window) => window.id === sensor.surfaceId);
    const windowPolygonYUp = getWindowPolygonYUp(window);
    const calculatedWindowCoordSystem = getWindowLocalCoordSystem(
      windowPolygonYUp?.polygon
    );
    const offsetPosition = applySensorOffset(
      sensor?.position,
      sensorOffset,
      windowCoordSystem ?? calculatedWindowCoordSystem
    );
    return {
      ...sensor,
      utm_x: offsetPosition[0],
      utm_y: offsetPosition[1],
      utm_z: offsetPosition[2],
    };
  });

  return (
    <SphereInstancedMesh
      objects={objects}
      setColor={setColor}
      groupProps={{ onClick, onPointerEnter, onPointerLeave, "rotation-x": 0 }}
      radius={SPHERE_RADIUS}
    />
  );
};

export default React.memo(AddMeshSensors);
